import React, { useRef, useState, useEffect } from 'react';
import { Tooltip, Typography, TypographyProps } from '@mui/material';

interface TruncatedWithTooltipProps extends TypographyProps {
    children: string;
}

const TruncatedWithTooltip: React.FC<TruncatedWithTooltipProps> = ({ children, sx = {}, ...typographyProps }) => {
    const ref = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (el) {
            const isOverflowing = el.scrollWidth > el.clientWidth;
            setIsTruncated(isOverflowing);
        }
    }, [children]);

    const text = (
        <Typography
            {...typographyProps}
            ref={ref}
            sx={{
                display: 'block',
                overflow: 'hidden',
                ...(isTruncated && {
                    textOverflow: 'ellipsis'
                }),
                ...sx
            }}
            noWrap={isTruncated}>
            {children}
        </Typography>
    );

    return isTruncated ? (
        <Tooltip title={children} arrow>
            {text}
        </Tooltip>
    ) : (
        text
    );
};

export default TruncatedWithTooltip;
